import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'
const actions = crud(
	'custom_catalog',
	'el Catálogo personalizado',
	'los Catálogos personalizados'
)

const importCustomCatalogs = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/custom_catalog/import_custom_catalogs`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				options,
			}),
			successMessage: `Se agreron los catálogos personalizados correctamente.`,
		})
		showSuccessMessage(
			'Se registraron los catálogos personalizados correctamente.'
		)
		return res.body
	}
}

const deleteItemsList = (data) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/custom_catalog/delete_items_list`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				data,
			}),
		})
		if (res.body.success) {
			showSuccessMessage('Cambios guardados correctamente.')
			dispatch(actions.load({ force: true }))
		} else {
			showErrorMessage('Ha ocurrido un error al intentar esta acción')
		}

		return res.body
	}
}

const deleteCustomCatalogEntity = (data) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/custom_catalog/delete_custom_catalog_entity`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				data,
			}),
		})
		if (res.body.success) {
			showSuccessMessage('Este registro se ha eliminado.')
			dispatch({
				type: 'DELETE_CUSTOM_CATALOG',
				response: { id: data.item_id }
			})
		} else {
			showErrorMessage('Ha ocurrido un error al intentar esta acción')
		}

		return res.body
	}
}

export default {
	...actions,
	importCustomCatalogs,
	deleteItemsList,
	deleteCustomCatalogEntity,
}
